import React from "react";
import { ChatType, UserLogin } from "../../types";
import { format } from "date-fns";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { getFormattedDates } from "../../utils/timeConverter";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link } from "react-router-dom";

type ChatNavBarProps = {
  chatHeader: UserLogin[] | undefined;
  chatDetails: ChatType;
  myColor: string;
  id?: string;
  pickRandomColor?: (userId: string) => string;
};
const ChatNavBar: React.FC<ChatNavBarProps> = ({
  chatHeader,
  chatDetails,
  myColor,
  id,
  pickRandomColor,
}) => {
  const bgColor =
    pickRandomColor && chatDetails !== null && pickRandomColor(chatDetails.id);
  // console.log(chatDetails, "chatDetails");

  return (
    <div className="px-5 flex items-center border-b border-solid h-[66px]">
      <Link to={"/chat/e"}>
        <FaArrowLeftLong className="lg:hidden flex mr-4 text-darkGreen" />
      </Link>

      {chatHeader && chatDetails === null
        ? chatHeader?.map((header) => {
            const lastLoginSeconds = header?.lastSeen;
            const lastLoginTime = lastLoginSeconds?.seconds
              ? format(
                  new Date(
                    (lastLoginSeconds.seconds ?? 0) * 1000 +
                      (lastLoginSeconds.nanoseconds ?? 0) / 1e6
                  ),
                  "h:mm a"
                )
              : "";
            const _currentTime = format(Date.now(), "h:mm a");
            // console.log(header?.chatId, " header.chatId")
            // console.log("lastLoginSeconds: ", lastLoginTime);

            return (
              header &&
              header.id === id &&
              header.userName && (
                <div
                  className="flex gap-3 items-center"
                  key={header?.chatId + 2}
                >
                  <div className="h-10 w-10 shadow rounded-full">
                    {header?.profileImage &&
                    header.profileImage !== undefined ? (
                      <img
                        src={ipfsGatewayImage(header.profileImage!)}
                        alt=""
                        className="h-10 w-10 rounded-full"
                      />
                    ) : (
                      myColor && (
                        <div
                          className="h-10 w-10 shadow font-SegoeUI font-normal text-[18px]  text-[#FFF] capitalize rounded-full flex items-center justify-center"
                          style={{ background: myColor }}
                        >
                          {header?.userName[0][0]}
                        </div>
                      )
                    )}
                  </div>
                  <div className="flex flex-col">
                    <h1 className=" font-Roboto text-[15px] font-medium text-[#000000E4]">
                      {header?.userName}
                    </h1>
                    <h2 className="text-xs font-normal font-SegoeUI text-[#8E9297]">
                      {/* {isLoading && "...."} */}

                      {lastLoginTime === _currentTime
                        ? "Online"
                        : lastLoginSeconds !== undefined
                        ? `Last seen ${getFormattedDates(
                            lastLoginSeconds
                          )} at ${lastLoginTime}`
                        : "Offline"}
                    </h2>
                  </div>
                </div>
              )
            );
          })
        : chatDetails &&
          chatDetails.id === id! && (
            <div className="flex gap-3 items-center">
              <div className="h-10 w-10 shadow rounded-full">
                {chatDetails?.profileImage &&
                chatDetails.profileImage !== undefined ? (
                  <img
                    src={ipfsGatewayImage(chatDetails.profileImage!)}
                    alt=""
                    className="h-10 w-10 rounded-full"
                  />
                ) : (
                  chatDetails.name &&
                  bgColor &&
                  bgColor && (
                    <div
                      className="h-10 w-10 shadow font-SegoeUI font-normal text-[18px]  text-[#FFF] capitalize rounded-full flex items-center justify-center"
                      style={{ background: bgColor! }}
                    >
                      {chatDetails?.name[0][0]}
                    </div>
                  )
                )}
              </div>
              <div className="flex flex-col">
                <h1 className=" font-Roboto text-[15px] font-medium text-[#000000E4]">
                  {chatDetails?.name}
                </h1>
              </div>
            </div>
          )}
    </div>
  );
};

export default ChatNavBar;
